import mirrorCreator from "mirror-creator";

export default mirrorCreator([
    "TOGGLE_FULLSCREEN",
    "TOGGLE_THEME",
    "TOGGLE_SIDEBAR",
    "NEW_NOTIFICATIONS",
    "READ_NOTIFICATIONS",
    "PUT_DATA",
    "CLEAR_DATA",
]);
